import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "environments/environment";
import { PaginationList } from "../shared/grid/pagination-list.model";
import { PaginatedResponse } from "../shared/http/paginated-response.model";
import { AgentRequestMapper } from "./models/agent-request.mapper";
import {
  AgentRequest,
  AgentRequestCounts,
  NewAgentRequest,
} from "./models/agent-request.model";

@Injectable({ providedIn: "root" })
export class AgentRequestRepository {
  private http = inject(HttpClient);

  public getAgentRequestList(
    params: HttpParams = new HttpParams(),
  ): Observable<PaginationList<AgentRequest>> {
    return this.http
      .get<PaginatedResponse>(`${environment.apiUrl}/agent-request`, { params })
      .pipe(
        map(
          (list) =>
            new PaginationList<AgentRequest>(
              list.items.map(AgentRequestMapper.map),
              list.total,
            ),
        ),
      );
  }

  public getAgentRequest(id: number): Observable<AgentRequest> {
    return this.http
      .get(`${environment.apiUrl}/agent-request/${id}`)
      .pipe(map(AgentRequestMapper.map));
  }

  public create(
    quoteId: number,
    request: NewAgentRequest,
  ): Observable<AgentRequest[]> {
    return this.http
      .post<any[]>(
        `${environment.apiUrl}/quote/${quoteId}/agent-request`,
        AgentRequestMapper.toPayload(request),
      )
      .pipe(map((list) => list.map(AgentRequestMapper.map)));
  }

  // Already closed requests come back unchanged.
  public close(ids: number[]): Observable<AgentRequest[]> {
    return this.http
      .post<any[]>(`${environment.apiUrl}/agent-request/close`, {
        agentRequests: ids,
      })
      .pipe(map((list) => list.map(AgentRequestMapper.map)));
  }

  public getQuoteAgentRequestCounts(
    quoteId: number,
  ): Observable<AgentRequestCounts> {
    return this.http
      .get<any[]>(`${environment.apiUrl}/quote/${quoteId}/agent-request/count`)
      .pipe(map(AgentRequestMapper.mapCounts));
  }
}
